var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "header-auth" },
    [
      _vm.isAuthorize
        ? _c(
            "div",
            { staticClass: "header-auth__workspace tooltip-assist" },
            [
              _vm.isAuthorize &&
              _vm.otherVerticalSubs.financial_services &&
              _vm.otherVerticalSubs.financial_services.active
                ? _c(
                    "a",
                    {
                      staticClass: "header-auth__financial",
                      attrs: { href: _vm.fsUrl },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 160 160",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M8 40h2c1.24 1.502 2.48 3.006 3.691 4.531C15.255 46.287 16.803 47.186 19 48c-.53 3.92-1.427 7.638-2.5 11.438-4.794 17.327-2.156 33.326 6.406 48.964C30.636 121.9 42.324 130.791 57 136c15.257 4.098 29.193 3.954 44-2h3c1.535 1.645 1.535 1.645 3.063 3.813l1.535 2.144A448.833 448.833 0 01112 145c-16.655 9.517-37.555 10.896-56.063 6.5-20.52-6.64-37.025-18.794-47.746-37.688C6.607 110.588 5.261 107.364 4 104l-1.25-3.273C-3.717 80.743-1.152 58.63 8 40zM121.807 13.231C134.35 22.431 143.53 34.403 149 49l1.25 3.273c6.295 19.453 3.844 40.312-4.25 58.727-3.444-1.53-6.095-3.617-9-6l-3-2 .586-2.02c5.739-20.312 5.84-37.513-4.492-56.382C122.364 31.1 110.676 22.209 96 17c-12.607-3.386-22.782-3.477-35.45-.754A185.218 185.218 0 0151 18l-1.242-1.715-1.633-2.222-1.617-2.215C45.12 9.889 45.12 9.889 43 9l1-3a73.048 73.048 0 017.25-2.625l2.027-.656c22.982-7.315 48.725-2.987 68.53 10.512z",
                              fill: "#262053",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M131 113c3.406 2.147 5.81 4.104 7 8 .425 5.36.477 8.654-3 13-2.884 2.99-5.859 3.699-9.977 4.059-3.346-.097-5.313-1.15-8.023-3.059-3.427-3.878-4.674-6.967-4.383-12.043.906-4.631 3.384-7.253 7.133-9.894 4.104-1.342 7.13-1.32 11.25-.063z",
                              fill: "#2D2758",
                            },
                          }),
                          _c("path", {
                            attrs: {
                              d: "M34 15c3.923 2.319 6.55 4.647 8 9 .372 5.02.137 7.997-3 12-2.96 3.22-5.154 4.291-9.438 4.5-4.475-.209-7.154-1.507-10.562-4.5-2.58-4.215-2.55-8.188-2-13 1.3-3.148 2.551-4.617 5.125-6.813C26.189 14.51 29.676 14.07 34 15z",
                              fill: "#262053",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", [_vm._v("Financial Services")]),
                    ]
                  )
                : [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 160 160",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M8 40h2c1.24 1.502 2.48 3.006 3.691 4.531C15.255 46.287 16.803 47.186 19 48c-.53 3.92-1.427 7.638-2.5 11.438-4.794 17.327-2.156 33.326 6.406 48.964C30.636 121.9 42.324 130.791 57 136c15.257 4.098 29.193 3.954 44-2h3c1.535 1.645 1.535 1.645 3.063 3.813l1.535 2.144A448.833 448.833 0 01112 145c-16.655 9.517-37.555 10.896-56.063 6.5-20.52-6.64-37.025-18.794-47.746-37.688C6.607 110.588 5.261 107.364 4 104l-1.25-3.273C-3.717 80.743-1.152 58.63 8 40zM121.807 13.231C134.35 22.431 143.53 34.403 149 49l1.25 3.273c6.295 19.453 3.844 40.312-4.25 58.727-3.444-1.53-6.095-3.617-9-6l-3-2 .586-2.02c5.739-20.312 5.84-37.513-4.492-56.382C122.364 31.1 110.676 22.209 96 17c-12.607-3.386-22.782-3.477-35.45-.754A185.218 185.218 0 0151 18l-1.242-1.715-1.633-2.222-1.617-2.215C45.12 9.889 45.12 9.889 43 9l1-3a73.048 73.048 0 017.25-2.625l2.027-.656c22.982-7.315 48.725-2.987 68.53 10.512z",
                            fill: "#262053",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M131 113c3.406 2.147 5.81 4.104 7 8 .425 5.36.477 8.654-3 13-2.884 2.99-5.859 3.699-9.977 4.059-3.346-.097-5.313-1.15-8.023-3.059-3.427-3.878-4.674-6.967-4.383-12.043.906-4.631 3.384-7.253 7.133-9.894 4.104-1.342 7.13-1.32 11.25-.063z",
                            fill: "#2D2758",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M34 15c3.923 2.319 6.55 4.647 8 9 .372 5.02.137 7.997-3 12-2.96 3.22-5.154 4.291-9.438 4.5-4.475-.209-7.154-1.507-10.562-4.5-2.58-4.215-2.55-8.188-2-13 1.3-3.148 2.551-4.617 5.125-6.813C26.189 14.51 29.676 14.07 34 15z",
                            fill: "#262053",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "header-auth__disabled" }, [
                      _vm._v("Financial Services"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "Tooltip",
                      { staticClass: "tip", attrs: { size: "small" } },
                      [
                        _c("p", [
                          _vm._v("Email "),
                          _c(
                            "a",
                            { attrs: { href: "mailto:clientvalue@vixio.com" } },
                            [_vm._v("clientvalue@vixio.com")]
                          ),
                          _vm._v(" to activate this feature"),
                        ]),
                      ]
                    ),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isAuthorize
        ? _c(
            "div",
            { staticClass: "header-auth__workspace tooltip-assist" },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 448 512",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M64 48C37.5 48 16 69.5 16 96l0 320c0 26.5 21.5 48 48 48l320 0c26.5 0 48-21.5 48-48l0-320c0-26.5-21.5-48-48-48L64 48zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM325.7 197.7l-128 128c-3.1 3.1-8.2 3.1-11.3 0l-64-64c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L192 308.7 314.3 186.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3z",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm.workspaceAccess
                ? _c("p", { on: { click: _vm.handleWorkspace } }, [
                    _vm._v("VIXIO WORKSPACE\n    "),
                  ])
                : [
                    _c("p", { staticClass: "header-auth__disabled" }, [
                      _vm._v("VIXIO WORKSPACE"),
                    ]),
                    _vm._v(" "),
                    _c("Tooltip", {
                      staticClass: "tip",
                      attrs: { size: "small" },
                    }),
                  ],
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isAuthorize
        ? _c(
            "div",
            {
              staticClass: "header-auth__mytools",
              on: {
                mouseleave: function ($event) {
                  _vm.isMyToolsDropdown = false
                },
                mouseover: function ($event) {
                  _vm.isMyToolsDropdown = true
                },
              },
            },
            [
              _c("div", { staticClass: "header-auth__title mytools" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24.239",
                      height: "18.075",
                      viewBox: "0 0 24.239 18.075",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        id: "Icon:_Tools",
                        d: "M265.015,252.252l-.372-1.493a2.1,2.1,0,0,0-2.039-1.591h-.819a.56.56,0,1,0,0,1.12h.819a.981.981,0,0,1,.952.743l.3,1.219.233,1.121h.7v.6a.211.211,0,0,1-.213.211h-7.914v-.806l-.013-1.121a.934.934,0,0,0-.918-.77H251.85a.931.931,0,0,0-.913.77l-.02,1.121v.806H243a.21.21,0,0,1-.211-.211v-.6h.661l.266-1.121.305-1.219a.979.979,0,0,1,.951-.743h14.631a.56.56,0,0,0,0-1.12h-.632v-2.549a1.307,1.307,0,0,0-1.3-1.3H249.91a1.306,1.306,0,0,0-1.3,1.3v2.549h-3.631a2.1,2.1,0,0,0-2.039,1.592l-.373,1.492a.947.947,0,0,0-.893.944v.77a1.341,1.341,0,0,0,.811,1.225l.6,6.295a2.093,2.093,0,0,0,2.092,1.9h4.378a.946.946,0,0,0,.924-.771H257.1a.948.948,0,0,0,.93.771h4.378a2.094,2.094,0,0,0,2.092-1.9l.6-6.295a1.341,1.341,0,0,0,.811-1.225v-.77A.947.947,0,0,0,265.015,252.252Zm-9.11-3.084h-4.3v-1.192h4.3Zm-6.18-2.549a.184.184,0,0,1,.184-.184h7.759a.184.184,0,0,1,.184.184v2.549h-.973l0-2.112h-6.234l-.014,2.112h-.9Zm-.349,15.649h-4.2a.977.977,0,0,1-.977-.887l-.579-6.083h5.76Zm2.662-9.668h3.5v1.111h-3.5Zm0,2.232h3.5v1.858a.183.183,0,0,1-.184.184h-3.136a.184.184,0,0,1-.184-.184Zm5.045,6.665H250.5v-6.2h.421v1.393a1.306,1.306,0,0,0,1.3,1.3h3.136a1.306,1.306,0,0,0,1.3-1.3V255.3h.421Zm6.3-.117a.977.977,0,0,1-.977.887h-4.2V255.3h5.758Z",
                        transform: "translate(-241.67 -245.314)",
                        fill: "#003865",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("p", [_vm._v("My Tools")]),
              ]),
              _vm._v(" "),
              _vm.isMyToolsDropdown
                ? _c("div", { staticClass: "header-auth__dropdown" }, [
                    _c("ul", [
                      _c(
                        "li",
                        [
                          _vm.hasAccessTools
                            ? _c(
                                "nuxt-link",
                                { attrs: { to: "/reportbuilder" } },
                                [
                                  _vm._v(
                                    "\n            Report Builder\n          "
                                  ),
                                ]
                              )
                            : [
                                _c(
                                  "span",
                                  { staticClass: "header-auth__disabled" },
                                  [_vm._v("Report Builder")]
                                ),
                                _vm._v(" "),
                                _c("Tooltip", {
                                  staticClass: "tip",
                                  attrs: { size: "small" },
                                }),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "li",
                        [
                          _vm.hasAccessTools
                            ? _c(
                                "nuxt-link",
                                { attrs: { to: "/reportbuilder-us" } },
                                [
                                  _vm._v(
                                    "\n            Report Builder (US)\n          "
                                  ),
                                ]
                              )
                            : [
                                _c(
                                  "span",
                                  { staticClass: "header-auth__disabled" },
                                  [_vm._v("Report Builder (US)")]
                                ),
                                _vm._v(" "),
                                _c("Tooltip", {
                                  staticClass: "tip",
                                  attrs: { size: "small" },
                                }),
                              ],
                        ],
                        2
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isAuthorize
        ? _c(
            "div",
            {
              staticClass: "header-auth__profile",
              on: {
                mouseleave: function ($event) {
                  _vm.isDropdown = false
                },
                mouseover: function ($event) {
                  _vm.isDropdown = true
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "header-auth__title profile",
                  on: {
                    click: function ($event) {
                      _vm.isDropdown = true
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                      },
                    },
                    [
                      _c("path", {
                        staticClass: "cls-1",
                        attrs: {
                          id: "Icon:_Profile",
                          "data-name": "Icon: Profile",
                          fill: "#003865",
                          d: "M16.572,11.426a8.431,8.431,0,0,0-2.15-1.346.7.7,0,1,0-.571,1.285,7.031,7.031,0,0,1,1.793,1.117,2.8,2.8,0,0,1,.95,2.107v1.3a.7.7,0,0,1-.7.7H2.109a.7.7,0,0,1-.7-.7v-1.3a2.8,2.8,0,0,1,.95-2.107c.71-.624,2.78-2.076,6.644-2.076a5.209,5.209,0,1,0-3.169-1.08,9.775,9.775,0,0,0-4.4,2.1A4.21,4.21,0,0,0,0,14.59v1.3A2.112,2.112,0,0,0,2.109,18H15.891A2.112,2.112,0,0,0,18,15.891v-1.3A4.21,4.21,0,0,0,16.572,11.426ZM5.2,5.2A3.8,3.8,0,1,1,9,9,3.8,3.8,0,0,1,5.2,5.2Z",
                        },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n        " + _vm._s(_vm.profileMenu.title) + "\n      "
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.isDropdown
                ? _c("div", { staticClass: "header-auth__dropdown" }, [
                    _c(
                      "ul",
                      _vm._l(_vm.profileMenu.submenu, function (item, index) {
                        return _c(
                          "li",
                          { key: index },
                          [
                            !item.toolsAccessRequired ||
                            (item.toolsAccessRequired && _vm.hasAccessTools)
                              ? _c("nuxt-link", { attrs: { to: item.link } }, [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.title) +
                                      "\n          "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isAuthorize
        ? _c(
            "button",
            {
              staticClass: "header-auth__logout",
              on: { click: _vm.handleLogout },
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "16.83",
                    height: "19",
                    viewBox: "0 0 16.83 19",
                  },
                },
                [
                  _c(
                    "g",
                    { attrs: { transform: "translate(-35.861 0.501)" } },
                    [
                      _c("path", {
                        attrs: {
                          fill: "#003865",
                          d: "M47.354,66.878a.63.63,0,0,0-.816.355h0a.633.633,0,0,0,.356.817,7.155,7.155,0,1,1-5.236,0,.63.63,0,0,0,.021-1.164.624.624,0,0,0-.481-.008,8.415,8.415,0,1,0,6.157,0Z",
                          transform: "translate(0 -64.626)",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          fill: "#003865",
                          d: "M229.225,11.583a.7.7,0,0,0,.7-.7V.2a.7.7,0,1,0-1.406,0V10.88A.7.7,0,0,0,229.225,11.583Z",
                          transform: "translate(-184.909)",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("p", [_vm._v("LOGOUT")]),
            ]
          )
        : _c(
            "nuxt-link",
            { staticClass: "header-auth__logout", attrs: { to: "/login" } },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "18",
                    height: "18",
                    viewBox: "0 0 18 18",
                  },
                },
                [
                  _c("path", {
                    staticClass: "cls-1",
                    attrs: {
                      id: "Icon:_Profile",
                      "data-name": "Icon: Profile",
                      fill: "#003865",
                      d: "M16.572,11.426a8.431,8.431,0,0,0-2.15-1.346.7.7,0,1,0-.571,1.285,7.031,7.031,0,0,1,1.793,1.117,2.8,2.8,0,0,1,.95,2.107v1.3a.7.7,0,0,1-.7.7H2.109a.7.7,0,0,1-.7-.7v-1.3a2.8,2.8,0,0,1,.95-2.107c.71-.624,2.78-2.076,6.644-2.076a5.209,5.209,0,1,0-3.169-1.08,9.775,9.775,0,0,0-4.4,2.1A4.21,4.21,0,0,0,0,14.59v1.3A2.112,2.112,0,0,0,2.109,18H15.891A2.112,2.112,0,0,0,18,15.891v-1.3A4.21,4.21,0,0,0,16.572,11.426ZM5.2,5.2A3.8,3.8,0,1,1,9,9,3.8,3.8,0,0,1,5.2,5.2Z",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("p", [_vm._v("LOGIN")]),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }